import React, { useContext } from "react";
import { FetchBoundary } from "../../../common/FetchBoundary";
import { PurchaseValidationContext } from "../../PurchaseValidationContext";
import { useFetch } from "../../../Hooks/useFetch";
import { UnassignedWarningPanel } from "../UnassignedWarningPanel";
import { displayBalance, displayCurrency } from "../../../utils/Helpers";
import { ProductPurchaseRow } from "../ProductPurchaseRow";
import { AccountActionCard } from "../AccountActionCard";
import { PurchasesByIdentifier } from "./PurchasesByIdentifier";

export const AccountIntegrityTab = () => {
  const { accounts, accountModal } = useContext(PurchaseValidationContext);

  const account = accounts.find((acc) => acc.id === accountModal?.accountId) ?? {};

  const productPurchasesFetcher = useFetch(
    `/api/covered_entities/${account.id_340b}/accounts/${account.id}/purchases_by_product`
  );
  const productPurchases = productPurchasesFetcher.data?.purchases ?? [];
  const unenforcedProductPurchases = productPurchases.filter((p) => !p.enforced);

  return (
    <div className="p-4">
      {account.account_type == "unassigned" ? <UnassignedWarningPanel /> : null}

      <AccountActionCard account={account} productPurchases={productPurchases} />

      <div>
        <div className="mb-3">
          <div className="t--500 pb-2">Purchases by Product</div>
          <div className="t--sm t--secondary">
            The purchases for the products listed below require claim submissions to validate.
          </div>
        </div>

        <FetchBoundary {...productPurchasesFetcher}>
          <div className="t--left t--sm container-fluid row-border-rounded">
            <div className="row align-items-center py-3 row-header t--500">
              <div className="col col-1"></div>
              <div className="col col-4">Product / NDC-11</div>
              <div className="col col-2">Unvalidated Purchases</div>
              <div className="col col-3">Unvalidated Purchase Units</div>
              <div className="col col-2">Claim Units</div>
            </div>
            {productPurchases
              .sort((a, b) => b.outstanding_purchase_count - a.outstanding_purchase_count)
              .filter((p) => p.enforced)
              .map((purchase) => (
                <ProductPurchaseRow purchase={purchase} key={purchase.product_name} />
              ))}
          </div>
        </FetchBoundary>
      </div>

      {unenforcedProductPurchases.length > 0 ? (
        <div>
          <div className="my-3">
            <div className="t--500 pb-2">Purchases by Product - No Validation Needed</div>
            <div className="t--sm t--secondary">
              The purchases for the products listed below do not require validation at this time.
            </div>
          </div>

          <div className="t--left t--sm container-fluid row-border-rounded">
            <div className="row align-items-center py-3 row-header t--500">
              <div className="col col-1"></div>
              <div className="col col-4">Product</div>
              <div className="col col-2">Purchases</div>
              <div className="col col-3">Purchase Units</div>
              <div className="col col-2">Claim Units</div>
            </div>
            {unenforcedProductPurchases
              .sort((a, b) => b.outstanding_purchase_count - a.outstanding_purchase_count)
              .map((purchase) => (
                <ProductPurchaseRow purchase={purchase} key={purchase.product_name} />
              ))}
          </div>
        </div>
      ) : null}

      <PurchasesByIdentifier account={account} />
    </div>
  );
};
